import styled, { css } from 'styled-components';
export const ItemContainer = styled.div `
  display: flex;
  align-items: center;

  min-height: 40px;
  padding-left: var(--space-400);
  padding-right: var(--space-400);

  font-size: var(--font-size-400);
  color: var(--text-primary);
  cursor: pointer;

  &:hover {
    background: var(--bg-secondary);
  }

  ${({ $active }) => $active &&
    css `
      background: var(--bg-tertiary) !important;
    `}
`;
